import CartProduct from '../../types/CartTypes'
import { calculateCartItemTotal } from '@/lib/priceConversions'

export type CartTotals = {
  totalPrice: number
  totalQuantity: number
}

const getTotal = (cartItems: CartProduct[]): CartTotals => {
  const totalPrice = cartItems.reduce(
    (sum, item) => sum + calculateCartItemTotal(item),
    0
  )

  const totalQuantity = cartItems.reduce(
    (sum, item) => sum + Number(item.quantity ?? 0),
    0
  )

  return { totalPrice, totalQuantity }
}

export default getTotal
